var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortUpLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2915 11.6673C12.2915 12.0125 12.0117 12.2923 11.6665 12.2923H1.6665C1.32133 12.2923 1.0415 12.0125 1.0415 11.6673C1.0415 11.3221 1.32133 11.0423 1.6665 11.0423H11.6665C12.0117 11.0423 12.2915 11.3221 12.2915 11.6673Z",
    fill: "#9897A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.95817 8.33398C8.95817 8.67916 8.67835 8.95898 8.33317 8.95898H1.6665C1.32133 8.95898 1.0415 8.67916 1.0415 8.33398C1.0415 7.98881 1.32133 7.70898 1.6665 7.70898H8.33317C8.67835 7.70898 8.95817 7.98881 8.95817 8.33398Z",
    fill: "#9897A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.62484 5.00065C5.62484 5.34583 5.34502 5.62565 4.99984 5.62565H1.6665C1.32133 5.62565 1.0415 5.34583 1.0415 5.00065C1.0415 4.65547 1.32133 4.37565 1.6665 4.37565H4.99984C5.34502 4.37565 5.62484 4.65547 5.62484 5.00065Z",
    fill: "#9897A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6248 15.0007C15.6248 15.3458 15.345 15.6257 14.9998 15.6257H1.6665C1.32133 15.6257 1.0415 15.3458 1.0415 15.0007C1.0415 14.6555 1.32133 14.3757 1.6665 14.3757H14.9998C15.345 14.3757 15.6248 14.6555 15.6248 15.0007Z",
    fill: "#9897A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3912 2.89204C15.6353 2.64796 16.031 2.64796 16.2751 2.89204L18.7751 5.39204C19.0192 5.63612 19.0192 6.03185 18.7751 6.27593C18.531 6.52 18.1353 6.52 17.8912 6.27593L16.4582 4.84287V11.6673C16.4582 12.0125 16.1783 12.2923 15.8332 12.2923C15.488 12.2923 15.2082 12.0125 15.2082 11.6673V4.84287L13.7751 6.27593C13.531 6.52 13.1353 6.52 12.8912 6.27593C12.6472 6.03185 12.6472 5.63612 12.8912 5.39204L15.3912 2.89204Z",
    fill: "#9897A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortUpLight);
export default __webpack_public_path__ + "static/media/sort-up-light.4faa07b0545cb1939998d7b2636b0f13.svg";
export { ForwardRef as ReactComponent };